import { render, staticRenderFns } from "./IconEditSetting.vue?vue&type=template&id=49400aa8"
import script from "./IconEditSetting.vue?vue&type=script&lang=js"
export * from "./IconEditSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports